export const currency = '₴'

export const MOBILE_DIVIDER_OFFSET = 150
export const MENU_SCREEN_MOBILE = 1280
export const FILTER_SCREEN_MOBILE = 720

export const PHONE_MASK = '+38(099) 99 99 999'
export const PHONE_MASK_CHAR = '_'
export const EDRPOU_MASK = '999999999999'


export const doughnutColors: any = {
    rdn: '#F87171',
    delta: '#FCA5A5',
    marja: '#FFC8C8',
    transfer: '#FEE2E2',
    imbalance: '#FFF0F0',
    total_fix: '#FFF2EC',
    imbalance_tolerance: '#FFDFD3',
    total_nds: '#FFD0BE',
    class1: '#FFAA8B',
    class2: '#FF8E65',
    fact: '#FF7340',
    declared: '#F25219',

    fact_class1: '#F87171',
    fact_class2: '#F87171',
    fact_fix_price: '#F87171',
    delta_cons: '#F87171',
}
export const pieColors: any = {
    declared: '#444248',
    fact: '#C4B5FD',
    delta_cons: '#F87171',
}
export const chartColors: { [key: string]: string } = {
    rdn: '#E4DDFF',
    transfer: '#C4B5FD',
    class1: '#8E70FF',
    class2: '#444248',
    declared: "#444248",
    fact: "#BDB4FE",
    declared_delta_less_6: "#73CD88",
    declared_delta_more_6: "#F87171",
    data_cons: '#BDB4FE',
    data_declared: "#444248"
}